class OhsFileBoxPermissions {
  view: boolean;

  create: boolean;

  edit: boolean;

  delete: boolean;

  constructor(flag: boolean) {
    this.view = flag;
    this.create = flag;
    this.edit = flag;
    this.delete = flag;
  }
}

export default OhsFileBoxPermissions;
